import { memo, useCallback } from 'react';
import type { useForm } from 'react-hook-form';

import { Label } from '@seuk/design-system/atoms';
import { Checkbox } from '@seuk/design-system/molecules';

import type { ContactOptionsFormValues } from '../forms/types';

const otherCheckboxesNames = ['emailCheckBox', 'phoneCheckBox', 'postCheckBox'] as const;

export interface ContactOptionsProps {
  methods: unknown;
  //methods: ReturnType<typeof useForm>;
}

export const ContactOptions = memo(({ methods: formMethods }: ContactOptionsProps) => {
  // todo fix methods types
  const methods = formMethods as ReturnType<typeof useForm<ContactOptionsFormValues>>;

  const onAllCheckboxChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.currentTarget.checked;
      methods.setValue('emailCheckBox', newValue);
      methods.setValue('phoneCheckBox', newValue);
      methods.setValue('postCheckBox', newValue);
    },
    [methods]
  );

  const onOtherCheckboxChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = otherCheckboxesNames.every((name) => {
        if (e.currentTarget.name === name) {
          return e.currentTarget.checked;
        }
        return methods.getValues(name);
      });

      methods.setValue('allTheAboveCheckBox', newValue);
    },
    [methods]
  );

  return (
    <div>
      <div>
        You can choose your marketing preferences below. These let you decide how you’d like to hear from Shell Energy
        UK Ltd. By opting in you will be kept informed about:
        <ul>
          <li>Our energy supply and solutions offering</li>
          <li>Events, newsletters, webinars, surveys, emails, company and industry news</li>
        </ul>
      </div>
      <Label>How would you like to hear from us?</Label>
      <Checkbox label="Email" {...methods.register('emailCheckBox')} onChange={onOtherCheckboxChange} />
      <Checkbox label="Phone" {...methods.register('phoneCheckBox')} onChange={onOtherCheckboxChange} />
      <Checkbox label="Post" {...methods.register('postCheckBox')} onChange={onOtherCheckboxChange} />
      <Checkbox label="All The Above" {...methods.register('allTheAboveCheckBox')} onChange={onAllCheckboxChange} />
    </div>
  );
});

ContactOptions.displayName = 'ContactOptions';
